import React, { FC } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _get from 'lodash/get';

import imageSources from '../../../../../constants/imageSources/imageSources';
import * as Styled from './styles';
import { TAppState } from '../../../../../reducers';

const emptyStateMsg = (isAdminOrParentAdmin: boolean, integration: string) => {
    if (isAdminOrParentAdmin && integration !== 'APP') {
        return 'Uploading and managing images is available only on app.bananatag.com.';
    }
    if (isAdminOrParentAdmin && integration === 'APP') {
        return 'Click “Upload to Folder” to get started.';
    }
    return 'You need to be an Admin/Parent Admin to upload images.';
};

interface IProps {
    canManageLibrary: boolean,
    isAdminOrParentAdmin: boolean,
    integration: string,
}

const EmptyState: FC<IProps> = ({ canManageLibrary, isAdminOrParentAdmin, integration }) => (
    <Styled.EmptyStateDiv>
        <div>
            <Styled.EmptyStateImg src={imageSources.FOLDER_EMPTY_STATE} alt="This folder is empty" />
            {canManageLibrary && (
                <Styled.ArrowImg src={imageSources.EMPTY_FOLDER_ARROW_UP} alt="This folder is empty" />
            )}
            <Styled.EmptyFolderMsg>
                This folder is empty.
            </Styled.EmptyFolderMsg>
        </div>
        <div>
            <Styled.ActionHelperMsg>
                {emptyStateMsg(isAdminOrParentAdmin, integration)}
            </Styled.ActionHelperMsg>
        </div>
    </Styled.EmptyStateDiv>
);

const mapStateToProps = (state: TAppState) => ({
    isAdminOrParentAdmin: _get(state, 'session.user.isAdminOrParentAdmin', 'BASE_USER'),
    integration: _get(state, 'session.integration', ''),
});

EmptyState.propTypes = {
    canManageLibrary: PropTypes.bool.isRequired,
    isAdminOrParentAdmin: PropTypes.bool.isRequired,
    integration: PropTypes.string.isRequired,
};

export default connect(mapStateToProps)(EmptyState);
